module.exports = __webpack_public_path__ + "img/icon-compliance-hub.91c9cf0b.svg";